import React, { useEffect, useState, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { CommonUtil } from '../../utils/commonUtil';
import { Dropdown } from 'primereact/dropdown';
import { useRecoilValue, useRecoilValueLoadable } from 'recoil';
import { myInfoSelector } from '../../recoil/selectors';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import dayjs from 'dayjs';
import { shopListState } from '../../recoil/atoms';

const SendSMS = ({
  onHide,
  smsData,
  setSmsData,
  customerInfo,
  showSmsType,
  postSms,
  loading,
}) => {
  const myInfoLoadable = useRecoilValueLoadable(myInfoSelector);
  const aid = myInfoLoadable.contents.associationInfo?.associationId ?? '18';
  const shopList = useRecoilValue(shopListState);
  const customerShop = shopList.find(
    (item) => item.value === customerInfo.shopId
  );

  // 사용자가 선택한 발송방법을 유지하기 위한 상태
  const [selectedMsgType, setSelectedMsgType] = useState('at');

  const makeContent = useCallback(
    (type, customerInfo, partnerInfo, addDocs) => {
      let str = '';
      // console.log(partnerInfo);
      if (addDocs) {
        str = addDocs
          .map((el) => '- ' + el)
          .toString()
          .replace(/,/g, '\n');
      }

      let checkP = 0;
      let insurP = 0;
      let totalP = 0;
      let checkDate = '';
      let count = 0;
      let carInfo = '';
      if (!!customerInfo?.paymentInfo) {
        if (customerInfo.paymentInfo.length > 1) {
          customerInfo.paymentInfo.map(
            (el) => (checkP = checkP + el.checkPriceTotal)
          );
          customerInfo.paymentInfo.map(
            (el) => (insurP = insurP + el.insurancePriceTotal)
          );
          totalP = checkP + insurP;
          count = `성능점검 총 ${customerInfo.paymentInfo.length}건`;
        } else {
          checkP = customerInfo.paymentInfo[0].checkPriceTotal;
          insurP = customerInfo.paymentInfo[0].insurancePriceTotal;
          totalP = checkP + insurP;
          checkDate = customerInfo.paymentInfo[0].checkDate;
          checkDate = dayjs(checkDate).format('YYYY-MM-DD');
          carInfo = `[${customerInfo.paymentInfo[0].licensePlateNumber}] ${customerInfo?.paymentInfo[0]?.carName}`;
        }
      }
      // console.log(checkP, insurP);

      switch (type) {
        case 'SAFE6_CUSTOMER':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            destAddr: `${customerInfo?.contact}`,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA10',
            contents: `${
              customerInfo?.carNbr
            } 딜러님,\n위 차량은 세이프6 대상차량이며, ${
              customerInfo?.shopName ?? '매매상사'
            }와의 계약에 따라 국산(4만)/수입(15만) 를 아래 고정계좌로 입금 바랍니다.\n\n1. 가상고정계좌 ${
              customerInfo?.bankAccountNo && customerInfo?.bankName
                ? `${customerInfo?.bankAccountNo} (${customerInfo?.bankName})`
                : '(계좌번호 문의 필요)'
            }\n- 입금자명 : ${
              customerInfo?.carNbr
            } (차량번호 필수)\n\n2. 주의사항\n- 입금자명 이 불명확한 경우 차량이보증 제외 대상이 될수 있습니다.\n- 상사별 2회~3회차 입금이 확인이 되지 않으면, ${
              customerInfo?.shopName
            } 의 세이프6 계약이 종료됨을 알려드립니다.\n\n3. 추가 가입\n- a/s잔류 , 당사자거래된 위탁차량의 세이프6 가입을 원하시면 사무장님에게 이야기 주시면 처리 여부를 알수 있습니다.`,
          }));
          break;
        case 'PAYMENT_T':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            destAddr: `${customerInfo?.paymentInfo[0]?.customerContact}`,
            contents: `안녕하세요.\n${
              customerInfo?.paymentInfo[0]?.customerCompanyName
            } ${customerInfo?.paymentInfo[0]?.customerName}님, ${
              customerInfo?.shopName
            }입니다.\n\n${
              checkDate ? checkDate : count
            }\n${carInfo}\n- 보험료 : ${insurP
              ?.toString()
              ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원\n\n${
              customerInfo?.bankName
            } ${customerInfo?.bankAccount}\n${
              customerInfo?.bankAccountName
            }\n\n보험료 매도시(후불결제)\n${
              checkDate && '차량번호로 '
            }입금 부탁드립니다.`,
          }));
          break;
        case 'PAYMENT':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            destAddr: `${customerInfo?.paymentInfo[0]?.customerContact}`,
            contents: `안녕하세요.\n${
              customerInfo?.paymentInfo[0]?.customerCompanyName
            } ${customerInfo?.paymentInfo[0]?.customerName}님, ${
              customerInfo?.shopName
            }입니다.\n\n${
              checkDate ? checkDate : count
            }\n${carInfo}\n- 성능비 : ${checkP
              ?.toString()
              ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원\n- 보험료 : ${insurP
              ?.toString()
              ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원\n- 합계금액 : ${totalP
              ?.toString()
              ?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원\n\n${
              customerInfo?.bankName
            } ${customerInfo?.bankAccount}\n${
              customerInfo?.bankAccountName
            }\n\n성능비 건별/월별 결제가능\n보험료 매도시(후불결제)\n${
              checkDate && '차량번호로 '
            }입금 부탁드립니다.`,
          }));
          break;
        case 'REPORT':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            url: '',
            contents: `[성능점검 안내]\n\n안녕하세요?\n${customerInfo?.shop.shopName} 입니다.\n성능점검이 완료되었습니다.\n\n- 차량번호: ${customerInfo?.licensePlateNumber}\n- 성능점검번호: ${customerInfo?.PRFOMNC_CHCK_NO}\n\n성능점검에 최선을 다하겠습니다.\n감사합니다.`,
          }));
          break;
        case 'APP_DOWNLOAD':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            url: '',
            sourceAddr: '15332729',
            contents: `자동차 성능 상태점검 책임보험 접수 방법 및 서류 안내 드립니다.\n-이름은 차주 성함으로 기재해 주세요.\n-연락처는 접수자 연락처로 기재해 주세요.\n\n-휴대폰 스토어에 맞는 어플리케이션 다운 후 아래 서류 첨부\n\n[플레이스토어]\nhttps://play.google.com/store/apps/details?id=kr.co.carmon.srtpa\n[앱스토어]\nhttps://apps.apple.com/app/%EC%97%90%EC%8A%A4%EC%95%8Csr/id6511209702\n\n<차주 필수 서류>\n1. 접수일 기준 촬영한 날짜가 확인되는 현재 계기판 주행거리 사진 (메모지에 오늘 날짜 기재 후 같이 두고 촬영 또는 앨범에서 상세정보 캡쳐)\n★ 날짜 필수로 확인되어야 합니다 ★\n2. 차주 본인 명의 자동차등록증\n3. 차량 구매 시 자필로 작성한 매수인용 계약서(자동차 인도일 기재 필수)\n4. 자동차성능·상태 점검 책임보험 가입증명서(어플 기타서류에 첨부)\n\n* 법인명의차량_사업자등록증, 비영리단체_고유번호증 ,리스차량_리스계약서 추가로 첨부하셔야 합니다. (어플 기타서류에 첨부)\n\n<딜러에게 요청하실 필수 서류>\n★ 마지막 단계에서 딜러 연락처 입력 시 딜러에게 서류첨부 카카오톡이 전송됩니다. 카톡으로 서류 첨부되어야 정상 접수됩니다.\n\n1. 자필로 작성한 매도인용 계약서(자동차 인도일 기재 필수)\n2. 성능점검기록부 앞, 뒤\n - 매매상사 직인, 작성일자, 차주 성함, 서명 필수\n3. 자동차 등록원부(갑)\n\n★ 보증기간 내에 2,000km 넘지 않게 모든 서류 완료 후 차량 입고까지 해주셔야 하니 기간 유의 부탁드립니다.\n\n★ 순차적으로 서류 검토 후 입고점 정보와 모든 안내는 어플 알림 또는 문자나 카카오톡으로 전송됩니다.`,
          }));
          break;
        case 'APP_DOWNLOAD_SAFE6':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            url: '',
            sourceAddr: '15517031',
            contents: `\"Safe 6 보증서비스\" 접수 방법 및 서류 안내 드립니다.\n- 이름은 차주 성함으로 접수해 주세요.\n- 연락처는 접수자 연락처로 기재해 주세요.\n\n사용하시는 휴대폰 스토어에 맞는 URL 링크 눌러서 설치 후 아래 서류를 첨부해 주세요.\n[플레이스토어]\nhttps://play.google.com/store/apps/details?id=kr.co.carmon.srtpa\n[앱스토어]\nhttps://apps.apple.com/app/%EC%97%90%EC%8A%A4%EC%95%8Csr/id6511209702\n\n<고객님 서류>\n1. 고객님 명의 자동차등록증\n2. 현재기준 계기판 주행거리 사진\n3. 차량 구매 시 자필로 작성한 매수인용 계약서(자동차 인도일 기재 필수)\n* 법인명의 경우 사업자등록증, 비영리단체는 고유번호증 추가로 첨부하셔야 합니다.\n* 리스차량의 경우 리스계약서 추가로 첨부하셔야 합니다.\n- 어플 기타서류에 첨부\n\n<딜러에게 요청하실 서류>\n★ 마지막 단계에서 딜러 연락처 입력 시 딜러에게 서류첨부 카카오톡이 전송됩니다. 카톡 링크로 서류 첨부되어야 정상 접수됩니다.\n\n1. 자필로 작성한 매도인용 계약서(자동차 인도일 기재 필수)\n2. 성능점검기록부 앞, 뒤\n - 매매상사 직인, 작성일자, 차주 성함, 서명 필수\n3. 자동차 등록원부(갑)\n\n★ 보증기간 내에 10,000km 넘지 않게 차량 입고까지 해주셔야 하니 유의 부탁드립니다.\n\n★ 서류 확인 전화 문의는 업무처리에 지연이 됩니다. 접수 후 기다려 주시면 최대한 빠르게 확인하여 안내드리겠습니다.\n\n★ 순차적으로 서류 검토 후 입고점 정보와 모든 안내는 유선으로 드리지 않으며 앱 알림 또는 문자나 카카오톡으로 안내드립니다.`,
          }));
          break;
        case 'REJECTION':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            destAddr: `${customerInfo.customerContact}`,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA09',
            contents: `${customerInfo?.carNbr} 고객님, 안녕하세요. 자동차성능·상태점검책임보험의 "보증범위초과"로 보증이 불가하여 안내 드립니다.\n자세한 내용은 자동차365 Q&A 를 참고 부탁 드립니다.\n\n- 보증범위초과\n\n*자동차성능·상태점검책임보험의 보장기간\n- 자동차 인도일로부터 30일 또는 주행거리 2천킬로미터 이내 중 먼저 도래한 기준 이내\n\n*보증범위 안내\nhttps://www.car365.go.kr/web/contents/etc_qna_carcheck.do\n\n감사합니다. `,
          }));
          break;
        case 'CUSTOMER_DOCS':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA17',
            subject: preveSmsData.subject ? preveSmsData.subject : null,
            destAddr: `${customerInfo.customerContact}`,
            contents: `${
              customerInfo?.carNbr
            } 고객님, 안녕하세요.\n제출하신 서류의 보완이 필요하여 안내 드립니다.\n※ 어플 첫 화면에서 내차접수현황 -> 상단 오른쪽에 수정 버튼 누른 후 아래 서류 첨부해 주세요.\n\n${
              str +
              '\n\n★확인 전화 문의는 업무처리에 지연이 됩니다. 담당자가 순차적으로 검토 후 다시 안내드리겠습니다.'
            }\n\n감사합니다.`,
          }));
          break;
        case 'INFO_TO_CUSTOMER':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA03',
            subject: preveSmsData.subject ? preveSmsData.subject : null,
            destAddr: `${customerInfo.customerContact}`,
            contents: `${
              customerInfo?.carNbr
            } 고객님, 안녕하세요. 방문하실 진단점 정보 안내 드립니다.\n\n- 진단점명 : ${
              partnerInfo?.partnerName ?? ''
            }\n- 연락처 : ${partnerInfo?.cellphone ?? ''}\n- 위치 : ${
              partnerInfo?.address ?? ''
            }\n\n감사합니다.`,
          }));
          break;
        case 'INFO_TO_PARTNER':
          const userInfo = `- 차량번호 : ${customerInfo?.carNbr}\r\n- 고객명 : ${
            customerInfo.customerName
            }\r\n- 연락처 : ${CommonUtil.Formatter.phone(
            customerInfo.customerContact
            )}\r\n- 접수일자 : ${dayjs(customerInfo.receiptDate).format(
              'YYYY-MM-DD'
            )}\r\n- 증상 : ${customerInfo.note}`;
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA18',
            subject: '사진 업로드 하기',
            destAddr: `${partnerInfo?.cellphone}`,
            contents: `안녕하세요. 방문예정 고객님의 정보를 전달 드립니다. 진단/수리점 전산을 통해 진단 사진을 업로드해주세요.\r\n\r\n${userInfo}\r\n\r\n감사합니다.`,
            // url: `${process.env.REACT_APP_BASE_URL}/upload/claim/aI=${aid}&carNum=${customerInfo?.carNbr}&cusN=${customerInfo?.customerName}&cusC=${customerInfo?.customerContact}&dealer=false&partner=true&pId=${partnerInfo?.partnerId}`,
          }));
          break;
        case 'PARTNER_UPLOAD_URL':
          const approvedDoc = partnerInfo?.partnerDocuments?.filter(
            (doc) => doc.documentCode === 'P_APPROVED'
          );
          const insuranceDoc = partnerInfo?.partnerDocuments?.filter(
            (doc) => doc.documentCode === 'P_INSURANCE_TEMPLATE'
          );
          const baseUrl = process.env.REACT_APP_CLOUDFRONT_BASE_URL || '';
          let approvedLink = '';
          if (approvedDoc?.some((el) => !el.filePath)) {
            approvedLink = '서류반영 버튼을 먼저 클릭해주세요.';
          } else {
            approvedLink = approvedDoc
              ?.map((el) => approvedLink + `${baseUrl}${el.filePath}`)
              .join('\n\n');
          }

          let insuranceLink = '';
          if (insuranceDoc?.some((el) => !el.filePath)) {
            insuranceLink = '서류반영 버튼을 먼저 클릭해주세요.';
          } else {
            insuranceLink = insuranceDoc
              ?.map((el) => insuranceLink + `${baseUrl}${el.filePath}`)
              .join('\n\n');
          }

          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA08',
            subject: '사진 업로드 하기',
            contents: `안녕하세요. ${customerInfo?.carNbr} 차량에 대해 수리 승인이 되었습니다.\n\n전달드리는 아래 링크를 통해 서류를 다운받으신 뒤 서류작성 후 진단/수리점 APP 을 통해 업로드 부탁 드립니다.\n\n1. 승인견적서 다운로드\n${approvedLink}\n\n2. 보험금청구 동의서 다운로드\n${insuranceLink}`,
          }));
          break;
        case 'PARTNER_UPLOAD_URL_FOR_APPLE':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA07',
            subject: '사진 업로드 하기',
            contents: `안녕하세요. 전달 드리는 URL 을 통해 수리 사진을 업로드해주세요.\n\n- 차량번호 : ${customerInfo?.carNbr}\n\n감사합니다.`,
            url: `${process.env.REACT_APP_BASE_URL}/upload/claim/aI=${aid}&carNum=${customerInfo?.carNbr}&cusN=${customerInfo?.customerName}&cusC=${customerInfo?.customerContact}&dealer=false&partner=true&pId=${partnerInfo?.partnerId}`,
          }));
          break;
        case 'DEALER_UPLOAD_URL':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA02',
            destAddr: `${
              customerInfo?.dealerContact ? customerInfo?.dealerContact : ''
            }`,
            subject: '서류 업로드 하기',
            contents: `안녕하세요. 전달 드리는 URL 을 통해 서류를 업로드해주세요.\n\n- 차량번호 : ${
              customerInfo?.carNbr
            }\n- 연락처 : ${CommonUtil.Formatter.phone(
              customerInfo?.customerContact
            )}\n\n[필요서류]\n${str}\n\n감사합니다.`,
            url: `${process.env.REACT_APP_BASE_URL}/upload/claim/aI=${aid}&carNum=${customerInfo?.carNbr}&cusN=${customerInfo?.customerName}&cusC=${customerInfo?.customerContact}&dealer=true&partner=false&pId=${partnerInfo?.partnerId}`,
          }));
          break;
        case 'DEALER_ADD_UPLOAD_URL':
          setSmsData((preveSmsData) => ({
            ...preveSmsData,
            msgType: selectedMsgType, // 사용자 선택값 유지
            msgSubType: 'TPA12',
            destAddr: `${
              customerInfo?.dealerContact ? customerInfo?.dealerContact : ''
            }`,
            subject: '서류 업로드 하기',
            contents: `안녕하세요. 제출하신 서류를 검토하던 중, 일부 서류에 보완이 필요하여 전달 드리는 URL 을 통해 다시 제출해 주시기를 부탁 드립니다.\n\n- 차량번호 : ${
              customerInfo?.carNbr
            }\n- 연락처 : ${CommonUtil.Formatter.phone(
              customerInfo?.customerContact
            )}\n\n[필요서류]\n${
              str +
              '\n\n★확인 전화 문의는 업무처리에 지연이 됩니다. 담당자가 순차적으로 검토 후 다시 안내드리겠습니다. '
            }\n\n감사합니다.`,
            url: `${process.env.REACT_APP_BASE_URL}/upload/claim/aI=${aid}&carNum=${customerInfo?.carNbr}&cusN=${customerInfo?.customerName}&cusC=${customerInfo?.customerContact}&dealer=true&partner=false&pId=${partnerInfo?.partnerId}`,
          }));
          break;
        default:
      }
    },
    [aid, setSmsData, selectedMsgType] // selectedMsgType 의존성 추가
  );

  const [partnerList, setPartnerList] = useState([]);
  const [partnerInfo, setPartnerInfo] = useState(null);
  const [addDocs, setAddDocs] = useState([]);
  const [originalContent, setOriginalContent] = useState('');

  const onAddDocsChange = (e) => {
    let _addDocs = [...addDocs];
    if (e.checked) _addDocs.push(e.value);
    else _addDocs.splice(_addDocs.indexOf(e.value), 1);
    setAddDocs(_addDocs);
  };

  // 초기 발송방법 설정 및 사용자 선택값 동기화
  useEffect(() => {
    if (smsData.msgType && !selectedMsgType) {
      setSelectedMsgType(smsData.msgType);
    }
  }, [smsData.msgType, selectedMsgType]);

  // showSmsType이 변경되어도 사용자 선택 발송방법 유지
  useEffect(() => {
    if (!!aid && showSmsType && addDocs && selectedMsgType !== 'new') {
      makeContent(showSmsType, customerInfo, null, addDocs);
    }
  }, [showSmsType, customerInfo, aid, addDocs, makeContent, selectedMsgType]);

  // 원본 메시지 내용 저장
  useEffect(() => {
    if (smsData.contents && !originalContent) {
      setOriginalContent(smsData.contents);
    }
  }, [smsData.contents, originalContent]);

  useEffect(() => {
    if ((showSmsType === 'PAYMENT' || showSmsType === 'SAFE6_CUSTOMER') && selectedMsgType !== 'new') {
      makeContent(showSmsType, customerInfo);
    }
  }, [showSmsType, customerInfo, makeContent, selectedMsgType]);

  useEffect(() => {
    if (smsData.partnerInfo) {
      setPartnerList(smsData.partnerInfo);
    }
  }, [smsData]);

  useEffect(() => {
    if (showSmsType && !!partnerInfo && selectedMsgType !== 'new') {
      makeContent(showSmsType, customerInfo, partnerInfo);
    }
  }, [showSmsType, customerInfo, partnerInfo, makeContent, selectedMsgType]);

  useEffect(() => {
    if (smsData.msgType === 'at' && selectedMsgType !== 'new') {
      if (
        showSmsType === 'PARTNER_UPLOAD_URL' ||
        showSmsType === 'PARTNER_UPLOAD_URL_FOR_APPLE'
      ) {
        setPartnerInfo(smsData.partnerInfo);
      }
      makeContent(showSmsType, customerInfo, partnerInfo, addDocs);
    }
  }, [
    smsData.msgType,
    partnerInfo,
    makeContent,
    smsData.partnerInfo,
    addDocs,
    customerInfo,
    showSmsType,
    selectedMsgType,
  ]);

  useEffect(() => {
    if (customerInfo?.warranty?.value === '6') {
      setSmsData((prev) => ({ ...prev, sourceAddr: '15517031' }));
    } else if (customerInfo?.shopName === '엔케이모터스') {
      setSmsData((prev) => ({
        ...prev,
        sourceAddr: smsData.sourceAddr,
      }));
    } else if (
      customerInfo?.warranty?.value === '2' ||
      customerInfo?.warranty?.value === '1'
    ) {
      setSmsData((prev) => ({ ...prev, sourceAddr: '15332729' }));
    }
    // else {
    //   setSmsData((prev) => ({
    //     ...prev,
    //     sourceAddr: smsData.sourceAddr,
    //   }));
    // }
  }, [customerInfo]);

  // 발송방법 변경 핸들러
  const handleMsgTypeChange = (e) => {
    const newMsgType = e.target.value;
    setSelectedMsgType(newMsgType);
    
    if (newMsgType === 'new') {
      setSmsData({ 
        ...smsData, 
        msgType: newMsgType,
        contents: '' 
      });
    } else {
      setSmsData({ 
        ...smsData, 
        msgType: newMsgType,
        contents: originalContent 
      });
    }
  };

  return (
    <Dialog
      onHide={onHide}
      modal
      visible
      style={{ width: '380px' }}
      header={'메세지 전송 - ' + SMSType[showSmsType].title}
      footer={() => (
        <div className="flex flex-auto align-items-start justify-content-center pt-2">
          <Button
            label="전송하기"
            icon="pi pi-check-circle"
            className=" mr-1"
            onClick={() =>
              SMSType[showSmsType].title.includes('안내') ||
              SMSType[showSmsType].title.includes('서류') ||
              SMSType[showSmsType].title.includes('거절') ||
              SMSType[showSmsType].title.includes('결제') ||
              SMSType[showSmsType].title.includes('수리')
                ? postSms(SMSType[showSmsType].title)
                : !!partnerInfo
                ? postSms(SMSType[showSmsType].title)
                : window.cerp.toast.warn('입고점을 선택해주세요.')
            }
            loading={loading}
          />
        </div>
      )}
    >
      {showSmsType === 'REPORT' || showSmsType === 'SAFE6_CUSTOMER' ? null : (
        <>
          <div className="">
            고객명 :{' '}
            {customerInfo?.customerName ||
              `[${customerInfo?.paymentInfo[0]?.customerCompanyName}] ${customerInfo?.paymentInfo[0]?.customerName}`}
          </div>
          <div className="my-2">
            연락처 :{' '}
            {CommonUtil.Formatter.phone(customerInfo?.customerContact) ||
              customerInfo?.paymentInfo[0]?.customerContact}
          </div>
          <Divider></Divider>
        </>
      )}
      <div className="flex align-items-center">
        <label>수신번호 :</label>
        <InputText
          value={CommonUtil.Formatter.phone(smsData.destAddr)}
          onChange={(e) => setSmsData({ ...smsData, destAddr: e.target.value })}
          className=" p-inputtext-sm ml-2"
          name="customerContact"
        />
      </div>
      <div className="flex align-items-center mt-1">
        <label>발송번호 :</label>
        <InputText
          value={CommonUtil.Formatter.phone(smsData.sourceAddr)}
          onChange={(e) =>
            setSmsData({ ...smsData, sourceAddr: e.target.value })
          }
          className=" p-inputtext-sm ml-2"
          name="customerContact"
        />
      </div>
      <div className="flex align-items-center mt-1">
        <label>발송방법 :</label>
        <div className="flex align-items-center mt-1">
          <RadioButton
            inputId="at"
            name="customerSearchBy"
            value="at"
            className="mx-2"
            checked={selectedMsgType === 'at'}
            onChange={handleMsgTypeChange}
          />
          <label htmlFor="at" className="mr-2">
            알림톡
          </label>
          <RadioButton
            inputId="lms"
            name="customerSearchBy"
            value="lms"
            className="mx-2"
            checked={selectedMsgType === 'lms'}
            onChange={handleMsgTypeChange}
          />
          <label htmlFor="lms" className="mr-2">문자</label>
          <RadioButton
            inputId="new"
            name="customerSearchBy"
            value="new"
            className="mx-2"
            checked={selectedMsgType === 'new'}
            onChange={handleMsgTypeChange}
          />
          <label htmlFor="new">신규작성</label>
        </div>
      </div>
      <Divider />
      <div>발송내역</div>
      {showSmsType === 'INFO_TO_CUSTOMER' ||
      showSmsType === 'INFO_TO_PARTNER' ? (
        <div className="flex mt-2 align-items-center gap-4">
          <div>입고점 선택</div>
          <Dropdown
            value={partnerInfo}
            onChange={(e) => setPartnerInfo(e.value)}
            options={partnerList}
            optionLabel="partnerName"
            placeholder="입고점을 선택해주세요"
            className="w-13rem"
            emptyMessage="입고점이 없습니다."
          />
        </div>
      ) : null}
      {showSmsType === 'CUSTOMER_DOCS' && (
        <div className="mt-1">
          <div className="flex flex-wrap gap-2">
            {DOC_TYPE_CUSTOMER.map((el, idx) => (
              <div key={idx}>
                <Checkbox
                  inputId={el.value}
                  name={el.value}
                  value={el.label}
                  onChange={(e) => onAddDocsChange(e)}
                  checked={addDocs.includes(el.label)}
                />
                <label htmlFor={el.value} className="mx-2">
                  {el.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      {showSmsType === 'DEALER_ADD_UPLOAD_URL' && (
        <div className="mt-1">
          <div className="flex flex-wrap gap-2">
            {DOC_TYPE_DEALER.map((el, idx) => (
              <div key={idx}>
                <Checkbox
                  inputId={el.value}
                  name={el.value}
                  value={el.label}
                  onChange={(e) => onAddDocsChange(e)}
                  checked={addDocs.includes(el.label)}
                />
                <label htmlFor={el.value} className="mx-2">
                  {el.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="mt-2">
        <InputTextarea
          disabled={selectedMsgType === 'at'}
          className="w-full mt-1"
          rows={4}
          autoResize
          value={smsData?.contents || ''}
          onChange={({ target: { value } }) =>
            setSmsData({ ...smsData, contents: value })
          }
          readOnly={showSmsType === 'REPORT'}
          placeholder={selectedMsgType === 'new' ? '메시지를 입력해주세요.' : ''}
        />
      </div>
    </Dialog>
  );
};

export default SendSMS;

const SMSType = {
  APP_DOWNLOAD: {
    title: '성능접수 안내',
  },
  APP_DOWNLOAD_SAFE6: {
    title: 'Safe6 접수 안내',
  },
  REJECTION: {
    title: '보증 거절 안내',
    content: '',
  },
  INFO_TO_CUSTOMER: {
    title: '입고점 정보 안내',
    content: '',
  },
  INFO_TO_PARTNER: {
    title: '진단점 고객정보 안내',
    content: '',
  },
  PARTNER_UPLOAD_URL: {
    title: '수리승인 및 양식 다운로드 안내',
    content: '',
  },
  PARTNER_UPLOAD_URL_FOR_APPLE: {
    title: '수리사진 업로드 안내',
    content: '',
  },
  DEALER_UPLOAD_URL: {
    title: '매매상사 서류 업로드 안내',
  },
  DEALER_ADD_UPLOAD_URL: {
    title: '매매상사 서류 재요청 안내',
  },
  CUSTOMER_DOCS: {
    title: '고객 서류 재요청 안내',
  },
  REPORT: {
    title: '최종고지 리포트(요약)',
  },
  PAYMENT: {
    title: '결제정보 안내',
  },
  PAYMENT_T: {
    title: '결제정보 안내',
  },
  SAFE6_CUSTOMER: {
    title: '결제정보 안내',
  },
};

const DOC_TYPE_CUSTOMER = [
  {
    value: 'C_DASHBOARD',
    label: '현재 기준 계기판 사진',
  },
  {
    value: 'C_CONTRACT',
    label: '매매계약서(매수인용)',
  },
  {
    value: 'C_CERTIFICATE',
    label: '차량등록증',
  },
  {
    value: 'C_ETC',
    label: '기타',
  },
];

const DOC_TYPE_DEALER = [
  {
    value: 'D_RECORD_1',
    label: '성능기록부',
  },
  {
    value: 'D_RECORD_2',
    label: '자동차등록원부(갑)',
  },
  {
    value: 'D_CONTRACT',
    label: '매매계약서(매도인용)',
  },
];
